const M = {
  en: {
    out_of_stock: (d) => `Not enough stock of ${d.product}: ${d.available} in vehicle, ${d.requested} requested`,
    credit_limit_exceeded: (d) => `Credit limit reached: open balance ${eur(d.exposure)} + this order ${eur(d.new_order)} exceeds ${eur(d.credit_limit)}. Ask a manager to approve.`,
    discount_limit_exceeded: (d) => `Discount above your limit of ${d.max_discount_pct}% — needs manager approval`,
    record_out_of_scope: "This record belongs to another salesperson — you can only work on your own customers and orders",
    forbidden: "You don't have permission for this action — ask your administrator",
    tenant_scope_required: "Your account is not linked to a company — contact your administrator",
    no_open_session: "Open your day first (Start day) before selling or collecting cash",
    session_already_open: "Your day is already open",
    delivery_not_found: "Delivery not found", delivery_not_ready: "This delivery was already completed or cancelled",
    invoice_not_payable: "This invoice can't be paid (already paid or cancelled)",
    payment_method_not_allowed: "This payment method is not allowed for your company",
    return_exceeds_sold: "You can't return more than was sold",
    visit_already_closed: "This visit is already closed", stop_not_found: "Route stop not found",
    invalid_sale: "Add at least one product and pick a customer", not_found: "Record not found (it may have been deleted)",
    transaction_in_progress: "Another action on this document is still running — try again in a moment",
    internal_error: "Server error — the order was NOT saved. Please try again; if it keeps failing, contact support",
    network: "No connection — check your signal and try again",
  },
  sq: {
    out_of_stock: (d) => `Stok i pamjaftueshëm për ${d.product}: ${d.available} në automjet, ${d.requested} u kërkuan`,
    credit_limit_exceeded: (d) => `Limiti i kredisë u arrit: bilanci i hapur ${eur(d.exposure)} + kjo porosi ${eur(d.new_order)} tejkalon ${eur(d.credit_limit)}. Kërko aprovim nga menaxheri.`,
    discount_limit_exceeded: (d) => `Zbritja tejkalon limitin tënd ${d.max_discount_pct}% — kërkon aprovim nga menaxheri`,
    record_out_of_scope: "Ky regjistër i përket një shitësi tjetër — mund të punosh vetëm me klientët dhe porositë e tua",
    forbidden: "Nuk ke leje për këtë veprim — kontakto administratorin",
    tenant_scope_required: "Llogaria jote nuk është e lidhur me një kompani — kontakto administratorin",
    no_open_session: "Hap ditën fillimisht (Fillo ditën) para se të shesësh ose të mbledhësh kesh",
    session_already_open: "Dita jote është tashmë e hapur",
    delivery_not_found: "Dorëzimi nuk u gjet", delivery_not_ready: "Ky dorëzim është përfunduar ose anuluar tashmë",
    invoice_not_payable: "Kjo faturë nuk mund të paguhet (e paguar ose e anuluar)",
    payment_method_not_allowed: "Kjo metodë pagese nuk lejohet për kompaninë tënde",
    return_exceeds_sold: "Nuk mund të kthesh më shumë se sa u shit",
    visit_already_closed: "Kjo vizitë është mbyllur tashmë", stop_not_found: "Ndalesa e rrugës nuk u gjet",
    invalid_sale: "Shto të paktën një produkt dhe zgjidh një klient", not_found: "Regjistri nuk u gjet (mund të jetë fshirë)",
    transaction_in_progress: "Një veprim tjetër në këtë dokument është ende duke u ekzekutuar — provo sërish pas pak",
    internal_error: "Gabim serveri — porosia NUK u ruajt. Provo sërish; nëse vazhdon, kontakto mbështetjen",
    network: "S'ka lidhje — kontrollo sinjalin dhe provo sërish",
  },
  sr: {
    out_of_stock: (d) => `Nema dovoljno zaliha za ${d.product}: ${d.available} u vozilu, traženo ${d.requested}`,
    credit_limit_exceeded: (d) => `Kreditni limit dostignut: otvoreni saldo ${eur(d.exposure)} + ova porudžbina ${eur(d.new_order)} premašuje ${eur(d.credit_limit)}. Zatražite odobrenje menadžera.`,
    discount_limit_exceeded: (d) => `Popust iznad vašeg limita od ${d.max_discount_pct}% — potrebno odobrenje menadžera`,
    record_out_of_scope: "Ovaj zapis pripada drugom prodavcu — možete raditi samo sa svojim kupcima i porudžbinama",
    forbidden: "Nemate dozvolu za ovu radnju — obratite se administratoru",
    tenant_scope_required: "Vaš nalog nije povezan sa kompanijom — obratite se administratoru",
    no_open_session: "Prvo otvorite dan (Počni dan) pre prodaje ili naplate",
    session_already_open: "Vaš dan je već otvoren",
    delivery_not_found: "Isporuka nije pronađena", delivery_not_ready: "Ova isporuka je već završena ili otkazana",
    invoice_not_payable: "Ova faktura se ne može platiti (već plaćena ili otkazana)",
    payment_method_not_allowed: "Ovaj način plaćanja nije dozvoljen za vašu kompaniju",
    return_exceeds_sold: "Ne možete vratiti više nego što je prodato",
    visit_already_closed: "Ova poseta je već zatvorena", stop_not_found: "Stanica rute nije pronađena",
    invalid_sale: "Dodajte bar jedan proizvod i izaberite kupca", not_found: "Zapis nije pronađen (možda je obrisan)",
    transaction_in_progress: "Druga radnja na ovom dokumentu je još u toku — pokušajte ponovo za trenutak",
    internal_error: "Greška servera — porudžbina NIJE sačuvana. Pokušajte ponovo; ako se ponavlja, kontaktirajte podršku",
    network: "Nema veze — proverite signal i pokušajte ponovo",
  },
};

const eur = (n) => `€${Number(n || 0).toFixed(2)}`;

export function mobileErr(e, lang = "en") {
  const dict = M[lang] || M.en;
  if (!e?.response) return dict.network;
  const d = e.response.data?.detail;
  const code = typeof d === "object" && d ? d.code : d;
  const m = dict[code] || M.en[code];
  if (m) return typeof m === "function" ? m(d) : m;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0]}: ${x.msg}`).join("; ");
  if (typeof code === "string") return code.replace(/_/g, " ");
  return e.message || dict.internal_error;
}
